import { render } from "./ArticleDetailModal.vue?vue&type=template&id=4eef5767&scoped=true"
import script from "./ArticleDetailModal.vue?vue&type=script&lang=js"
export * from "./ArticleDetailModal.vue?vue&type=script&lang=js"

import "./ArticleDetailModal.vue?vue&type=style&index=0&id=4eef5767&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4eef5767"]])

export default __exports__